<template>
  <div>
    <div id="vContents">
      <div id="vtitle">志愿者申请表</div>
      <div id="volhr"></div>
      <div id="addvolun">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="年龄" prop="age">
            <el-input v-model="addForm.age" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="age">
            <template style="text-align: left;">
              <el-radio v-model="addForm.sex" label="401">男</el-radio>
              <el-radio v-model="addForm.sex" label="402">女</el-radio>
            </template>
          </el-form-item>
          <el-form-item label="身份证号" prop="carid">
            <el-input v-model="addForm.carid" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="籍贯" prop="natives">
            <el-input v-model="addForm.natives" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="居住地址" prop="address">
            <el-input v-model="addForm.address" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="学历" prop="education">
            <template style="text-align: left;">
              <el-radio v-model="addForm.education" label="501">中专/高中</el-radio>
              <el-radio v-model="addForm.education" label="502">大专</el-radio>
              <el-radio v-model="addForm.education" label="503">本科</el-radio>
              <el-radio v-model="addForm.education" label="504">硕士</el-radio>
              <el-radio v-model="addForm.education" label="505">博士</el-radio>
              <el-radio v-model="addForm.education" label="506">其他</el-radio>
            </template>
          </el-form-item>
          <el-form-item label="专业" prop="major">
            <el-input v-model="addForm.major" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="addForm.phone" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </div>
    </div>
    <div id="mvContents">
      <div id="mvtitle">志愿者申请表</div>
      <div id="mvolhr"></div>
      <div id="maddvolun">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="年龄" prop="age">
            <el-input v-model="addForm.age" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="age">
            <template style="text-align: left;">
              <el-radio v-model="addForm.sex" label="401">男</el-radio>
              <el-radio v-model="addForm.sex" label="402">女</el-radio>
            </template>
          </el-form-item>
          <el-form-item label="身份证号" prop="carid">
            <el-input v-model="addForm.carid" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="籍贯" prop="natives">
            <el-input v-model="addForm.natives" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="居住地址" prop="address">
            <el-input v-model="addForm.address" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="学历" prop="education">
            <template style="text-align: left;">
              <el-radio v-model="addForm.education" label="501">中专/高中</el-radio>
              <el-radio v-model="addForm.education" label="502">大专</el-radio>
              <el-radio v-model="addForm.education" label="503">本科</el-radio>
              <el-radio v-model="addForm.education" label="504">硕士</el-radio>
              <el-radio v-model="addForm.education" label="505">博士</el-radio>
              <el-radio v-model="addForm.education" label="506">其他</el-radio>
            </template>
          </el-form-item>
          <el-form-item label="专业" prop="major">
            <el-input v-model="addForm.major" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="addForm.phone" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import qs from 'qs'
  export default {
    data() {
      return {
        loading: false,
        tableData: [],
        // 新增相关数据
        addFormVisible: true, // 新增页面是否开启
        addLoading: false,
        addForm: {
          name: '',
          age: '',
          sex: '',
          carid: '',
          natives: '',
          address: '',
          phone: '',
          education: '',
          major: ''
        },
        addFormRules: {
          name: [{
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }],
          age: [{
            required: true,
            message: '请输入年龄',
            trigger: 'blur'
          }],
          carid: [{
            required: true,
            message: '请输入身份证号',
            trigger: 'blur'
          }],
          natives: [{
            required: true,
            message: '请输入籍贯',
            trigger: 'blur'
          }],
          address: [{
            required: true,
            message: '请输入居住地址',
            trigger: 'blur'
          }],
          phone: [{
            required: true,
            message: '请输入公告内容',
            trigger: 'blur'
          }],
          education: [{
            required: true,
            message: '请输入学历',
            trigger: 'blur'
          }],
          major: [{
            required: true,
            message: '请输入专业',
            trigger: 'blur'
          }]
        }
      }
    },
    mounted() {
      if (this.isMobile()) {
        document.getElementById("vContents").style.display = "none"
      } else {
        document.getElementById("mvContents").style.display = "none";
        document.getElementById("vContents").style.display = "block"
      }
    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      showAddDialog: function() {
        this.addForm = {
          name: '',
          age: '',
          sex: '',
          carid: '',
          natives: '',
          address: '',
          phone: '',
          education: '',
          major: ''
        }
      },
      // 新增数据
      addSubmit: function() {
        let that = this;
        let url = this.HOST + '/api/v1/social/newlyVolunteer';
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            that.loading = true;
            let para = Object.assign({}, this.addForm)
            that.$axios.post(url, para).then(function(result) {
              console.log(result);
              if (result.data.code == 0) {
                that.$message.success({
                  showClose: true,
                  message: '申请已提交成功',
                  duration: 2000
                });
                that.$refs['addForm'].resetFields();
                that.addFormVisible = false;
                that.search();
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.data.message || '申请提交失败',
                  duration: 2000
                });
              }
            }, function(err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }).catch(function(error) {
              console.log(error)
            })
          }
        })
      }
    }
  }
</script>

<style>
  #vContents {
    display: none;
    width: 80%;
    margin: 0 10%;
  }

  #addvolun {
    width: 60%;
    margin: 10px 20%;

  }

  #volhr {
    width: 100%;
    height: 1px;
    border-bottom: 1px dotted #dbdbdb;
    float: left;
  }

  #vtitle {
    height: 60px;
    line-height: 60px;
  }

  .el-form-item__content {
    text-align: left;
    margin-left: 100px;
  }

  .el-radio+.el-radio {
    margin-left: 20px;
  }

  /*mobile*/
  #mvContents {
    margin: 0 10px;
  }

  #maddvolun {
    width: 100%;
    margin-top: 10px;
  }

  #mvolhr {
    width: 100%;
    height: 1px;
    border-bottom: 1px dotted #dbdbdb;
    float: left;
  }

  #mvtitle {
    height: 60px;
    line-height: 60px;
  }

  .el-form-item__content {
    text-align: left;
    margin-left: 100px;
  }

  .el-radio+.el-radio {
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/about/volunteer/volunbm.vue